function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "upload-icon");

var _ref2 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "16.48 11.78 16.48 18.52 3.52 18.52 3.52 11.78",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 1.69
});

var _ref3 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "5.77 6.33 10.02 1.48 14.23 6.28",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 1.69
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 10,
  y1: 15.15,
  x2: 10,
  y2: 4.83,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 1.69
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/upload-icon.4b194d08.svg";
export { SvgComponent as ReactComponent };